import { FeaturePermission } from '../../../../constants/feature.permission.helper';
import api from '../../../../scripts/api';
import translate from '../../../../scripts/core/tools/translate';
import environment from '../../../../scripts/environment';

const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);

export class StoreAfterSalesFactory {
    constructor({ options, currentMap }) {
        this.options = options;
        this.currentMap = currentMap;
    }

    getData() {
        const source = environment.get('CONFIG.FILTERS.SERVICE_TYPES');
        const sourceDealerStateAcronym = environment.get('CONFIG.FILTERS.DEALER_STATE_ACRONYMS');

        const dealerships = [
            {
                name: 'dealer_state_acronym_store_after_sales',
                position: 1,
                data: sourceDealerStateAcronym,
                fields: [
                    {
                        title: translate('Common.State'),
                        name: 'stateAcronym',
                        value: 'nome',
                        text: 'nome',
                        type: 'dropdown',
                        orderBy: "nome"
                    },
                ]
            }
        ];

        if (isAuthorized(FeaturePermission.LAYER_AFTER_SALES_NETWORK.filterServiceType)) {
            dealerships.push({
                name: 'serviceTypes',
                position: 2,
                data: source,
                fields: [
                    {
                        title: translate('Common.TypesOfServiceAfterSalesFilters'),
                        name: 'serviceTypes',
                        value: 'id',
                        text: 'nome',
                        type: 'multiselect',
                        orderBy: "nome"
                    },
                ]
            });
        }

        if (isAuthorized(FeaturePermission.LAYER_AFTER_SALES_NETWORK.filterNetworkType)) {
            const sourceNetworks = environment.get('CONFIG.FILTERS.CLIENT_NETWORKS');
            dealerships.push({
                name: 'networks',
                position: 1,
                data: sourceNetworks,
                fields: [
                    {
                        title: translate('Common.AfterSalesNetwork'),
                        name: 'networks',
                        value: 'networkId',
                        text: 'networkName',
                        type: 'multiselect',
                        orderBy: 'networkName'
                    }
                ],
            });
        }

        let data = [];

        if (this.options.type === 'network after sales' || this.options.type === 'store inactive after sales') {
            data = [
                ...data,
                ...dealerships
            ];
        }

        if (this.options.type === 'competitors after sales') {
            const sourceCompetitorsStateAcronym = environment.get('CONFIG.FILTERS.COMPETITORS_STATE_ACRONYMS');
            const sourceBrands = environment.get('CONFIG.FILTERS.BRANDS');
            const sourceNetworkStoreSize = environment.get('CONFIG.FILTERS.CLASSIFICATION_NETWORK_STORE');
            const sourceDealerTypes = environment.get('CONFIG.FILTERS.DEALER_TYPES');
            const sourceNetworks = environment.get('CONFIG.FILTERS.NETWORKS');

            if (isAuthorized(FeaturePermission.LAYER_AFTER_SALES_COMPETITORS.filterDealerType)) {
                data.push({
                    name: 'dealerTypes',
                    position: 4,
                    data: sourceDealerTypes,
                    fields: [
                        {
                            title: 'Tipo de Revendedor',
                            name: 'dealerTypes',
                            value: 'id',
                            text: 'nome',
                            type: 'dropdown',
                            orderBy: 'nome',
                        },
                    ],
                });
            }

            if (isAuthorized(FeaturePermission.LAYER_AFTER_SALES_COMPETITORS.filterNetwork)) {
                const networkFields = [
                    {
                        title: translate('Common.AfterSalesNetwork'),
                        name: 'networks',
                        value: 'networkId',
                        text: 'networkName',
                        type: 'multiselect',
                        orderBy: 'networkName',
                        skipAll: true
                    }
                ];

                if (isAuthorized(FeaturePermission.LAYER_AFTER_SALES_COMPETITORS.filterNetworkType)) {
                    networkFields.unshift({
                        title: 'Tipo de Rede',
                        name: 'networkTypes',
                        value: 'networkTypeId',
                        text: 'networkTypeName',
                        type: 'dropdown',
                        orderBy: 'networkTypeName',
                    });
                }

                data.push({
                    name: 'networks',
                    position: 3,
                    data: sourceNetworks,
                    fields: networkFields,
                });
            }

            if (isAuthorized(FeaturePermission.LAYER_AFTER_SALES_COMPETITORS.filterBrand)) {
                data.push({
                    name: 'brands',
                    position: 5,
                    data: sourceBrands,
                    fields: [
                        {
                            title: translate('Common.AfterSalesBrand'),
                            name: 'brands',
                            value: 'id',
                            text: 'nome',
                            type: 'multiselect',
                            orderBy: 'nome',
                            skipAll: true,
                        },
                    ],
                });
            }

            data = [
                ...data,
                {
                    name: 'competitors_state_acronym_store_after_sales',
                    position: 1,
                    data: sourceCompetitorsStateAcronym,
                    fields: [
                        {
                            title: translate('Common.State'),
                            name: 'stateAcronym',
                            value: 'nome',
                            text: 'nome',
                            type: 'dropdown',
                            orderBy: "nome"
                        },
                    ]
                }
            ];

            if (isAuthorized(FeaturePermission.LAYER_AFTER_SALES_COMPETITORS.filterNetworkSize)) {
                data = [
                    ...data,
                    {
                        name: 'classifications_network',
                        position: 2,
                        data: sourceNetworkStoreSize,
                        fields: [
                            {
                                title: 'Tamanho da Rede',
                                name: 'classifications',
                                value: 'id',
                                text: 'name',
                                type: 'multiselect',
                                skipAll: true,
                                orderBy: 'id'
                            },
                        ],
                    }
                ];
            }
        }
        return data;
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/filters/factory/storeAfterSales.factory.js